const state = {
  isLoading: false,
  isAppLoading: false,
  isAuthenticating: JSON.parse(localStorage.getItem("isAuthenticating"))
}

const getters = {
  isLoading(state) {
    return state.isLoading;
  },
  isAppLoading(state) {
    return state.isAppLoading;
  },
  isAuthenticating(state) {
    return state.isAuthenticating;
  }
}

const actions = {
  show({commit}) {
    commit("changeStatus", true);
  },
  hide({commit}) {
    commit("changeStatus", false);
  },
  showLoadApp({commit}) {
    commit("loadApp", true);
  },
  hideLoadApp({commit}) {
    commit("loadApp", false);
  },
  beginAuthentication({commit}) {
    commit("changeAuthenticationStatus", true)
  },
  endAuthentication({commit}) {
    commit("changeAuthenticationStatus", false)
  }
}

const mutations = {
  changeStatus(state, status) {
    state.isLoading = status;
  },
  loadApp(state, status) {
    state.isAppLoading = status;
  },
  changeAuthenticationStatus(state, status) {
    state.isAuthenticating = status;
    localStorage.setItem("isAuthenticating", JSON.stringify(status))
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
